import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ChakraProvider, ColorModeScript, extendTheme } from '@chakra-ui/react';
import { AuthProvider } from './context/AuthContext';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/Login';
import { AuthCallback } from './pages/AuthCallback';
import { ProtectedRoute } from './components/ProtectedRoute';
import { theme } from './theme';
import { AdvisorAgent } from './pages/AdvisorAgent';
import { EarningsCalendar } from './pages/EarningsCalendar';
import { MarketSearch } from './pages/MarketSearch';
import { AdvisorHistoryPage } from './pages/AdvisorHistory';
import { ScamAware } from './pages/ScamAware';

const globalStyle = {
  styles: {
    global: {
      'html, body': {
        fontFamily: "'Poppins', sans-serif",
      },
    },
  },
};

const updatedTheme = extendTheme(theme, globalStyle);

function App() {
  return (
    <>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <ChakraProvider theme={updatedTheme}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Home />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/holdings"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Dashboard />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/auth/callback"
                element={
                  <ProtectedRoute>
                    <AuthCallback />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/advisor"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <AdvisorAgent />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/earnings-calendar"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <EarningsCalendar />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/market-search"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <MarketSearch />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/advisor/history"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <AdvisorHistoryPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/scam-aware"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ScamAware />
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ChakraProvider>
    </>
  );
}

export default App;
